import React from 'react';

import { DelayedSuspense } from '@lumapps/lumx-suspense/components/DelayedSuspense';

const LazyReportTunnel = React.lazy(async () => {
    const { ReportTunnel } = await import(
        /* webpackChunkName: 'reports' */
        './ReportTunnel'
    );
    return { default: ReportTunnel };
});

export const ReportTunnel: React.FC<React.ComponentProps<typeof LazyReportTunnel>> = ({ isOpen, ...props }) => (
    <DelayedSuspense shouldLoad={isOpen}>
        <LazyReportTunnel isOpen={isOpen} {...props} />
    </DelayedSuspense>
);
